/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FcbSmsSuiviGridDtoPaginatedResults,
  FilterCriteriaInfo,
  SelectItem,
  SmsSuiviSearch,
} from '../models/index';
import {
    FcbSmsSuiviGridDtoPaginatedResultsFromJSON,
    FcbSmsSuiviGridDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
    SmsSuiviSearchFromJSON,
    SmsSuiviSearchToJSON,
} from '../models/index';

export interface SmsSuiviBaseSearchRequest {
    SmsSuiviSearch?: SmsSuiviSearch;
}

export interface SmsSuiviGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface SmsSuiviGetSelectItemsRequest {
    searchField: string;
}

/**
 * 
 */
export class SmsSuiviApi extends runtime.BaseAPI {

    /**
     */
    async smsSuiviBaseSearchRaw(requestParameters: SmsSuiviBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbSmsSuiviGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/SmsSuivi/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SmsSuiviSearchToJSON(requestParameters.SmsSuiviSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbSmsSuiviGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async smsSuiviBaseSearch(requestParameters: SmsSuiviBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbSmsSuiviGridDtoPaginatedResults> {
        const response = await this.smsSuiviBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async smsSuiviGetSearchCriteriasRaw(requestParameters: SmsSuiviGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/SmsSuivi/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async smsSuiviGetSearchCriterias(requestParameters: SmsSuiviGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.smsSuiviGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async smsSuiviGetSelectItemsRaw(requestParameters: SmsSuiviGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling smsSuiviGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/SmsSuivi/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async smsSuiviGetSelectItems(requestParameters: SmsSuiviGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.smsSuiviGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
